<template>
  <div class="router_view">
    <router-view v-if="isShowApp" v-slot="{ Component, route }">
      <transition-group :name="route.meta ? route.meta.transitionName : ''">
        <div key="1">
          <keep-alive :include="storeData.keepAliveInclude">
            <component :key="route.name" v-if="route.meta.keepAlive" :is="Component" @vue:mounted="componentOnMounted" />
          </keep-alive>
        </div>
        <component :key="route.name" v-if="!route.meta.keepAlive" :is="Component" @vue:mounted="componentOnMounted" />
      </transition-group>
    </router-view>
    <GlobalLoading></GlobalLoading>
    <GlobalBackToIndex
      v-if="
        !isApp() &&
          ![
            'myModuleHome',
            'ysfMessage',
            'videoVcPage',
            'shareVideo',
            'technicianList',
            'technicianDetail',
            'rankBill',
            'rankRule',
            'secondFloor',
            'techCoupon',
            'myAttention',
            'techManage',
            'redPackRain',
          ].includes($route.name)
      "
    ></GlobalBackToIndex>
    <GlobalBackToGrowth v-if="!isApp() && !['ysfMessage', 'videoVcPage', 'shareVideo'].includes($route.name)"></GlobalBackToGrowth>
    <GlobalTabbar v-if="$route.meta.TabBarShow"></GlobalTabbar>
    <component :is="asyncComponent" />
    <!-- 打开app，临时隐藏 -->
    <!-- <openAppPopup></openAppPopup> -->
    <!--回顶-->
    <GlobalBackTop></GlobalBackTop>
    <!--websocket弹窗-->
    <GlobalSocketPopup></GlobalSocketPopup>
  </div>
</template>

<script setup>
import { useIMWebSocket } from '@/hooks/useIMWebSocket'
import { bindUUidToUserId } from '@/plugins/umeng'
import { onMounted, onUnmounted, onBeforeMount, ref, provide, defineAsyncComponent, watch } from 'vue-demi'
import { setUserConfig } from '@umengfe/apm'
import dayjs from 'dayjs'
import { store } from '@/pinia/store'
import { req } from '@/api'
import { codeList } from '@/api/codeList'
import { wyAuthService } from '@/tsApi/service'
import { initAMap } from '@/hooks/useAMap.js'
import {
  getCID,
  getUrlData,
  resetArr,
  isWeiXin,
  isApp,
  checkAppHandle,
  isIos,
  checkIsNewPackage,
  isAndroid,
  getUrlChannelCode,
  isJwApp,
  jwAndroidApp,
  getServiceTel,
  checkIsInvite,
  utmsCheck,
  pageScrollUmengEmbedding,
  loadAliyunUploadSDK,
} from '@/utils'
import { isNotNeedInit, isNotLocationInit } from '@/hooks/useNotNeedInit'
import { useRouter } from 'vue-router'
import GlobalLoading from '@/components/GlobalLoading.vue'
import GlobalTabbar from '@/components/GlobalTabbar.vue'
import GlobalBackToIndex from '@/components/GlobalBackToIndex.vue'
import GlobalBackToGrowth from '@/components/GlobalBackToGrowth.vue'
import GlobalBackTop from '@/components/GlobalBackTop.vue'
import GlobalSocketPopup from '@/components/GlobalSocketPopup/index.vue'
import { hideLoading, showLoading } from '@/hooks/useVant'
// import openAppPopup from '@/views/homeModule/components/openAppPopup.vue'
import { sendDataToApp } from '@/hooks/useBridge'
import { onLCP, onFCP, onFID, onCLS } from 'web-vitals'
import { defaultAddress } from '@/hooks/useAMap'
import { isZLHost, isWYHost, isProdEnv, isPreEnv } from './config'

const router = useRouter()
const isShowApp = ref(false)
const storeData = store()
const isShowOpenAppPopup = ref(false) //外部浏览器打开或安装app
const asyncComponent = ref(null)
const { onMessage, checkMessage } = useIMWebSocket()
const scrollTimer = ref()
const lastScrollTop = ref(0)

onBeforeMount(() => {
  storeData.globalPrePageId = ''

  if (isProdEnv) {
    if (!isWeiXin() && !isWYHost) {
      // 非微信环境且非往约域名，重定向到往约域名
      location.href = 'https://h5.wangyuedaojia.com/' + location.hash
    } else if (isWeiXin() && !isZLHost) {
      // 微信环境且非助邻域名，重定向到助邻域名
      location.href = 'https://m.zhulinkeji.com/' + location.hash
    }
  } else if (isPreEnv) {
    if (!isWeiXin() && !isWYHost) {
      // 非微信环境且非往约域名，重定向到往约域名
      location.href = 'https://h5.wangyuedaojia.com/pre/' + location.hash
    } else if (isWeiXin() && !isZLHost) {
      // 微信环境且非助邻域名，重定向到助邻域名
      location.href = 'https://m.zhulinkeji.com/pre/' + location.hash
    }
  }
})

onMounted(async () => {
  if (isNotNeedInit()) {
    hideLoading()
    isShowApp.value = true
    return
  }
  showLoading()
  isShowApp.value = false
  storeData.isCloseOnOrderGoing = true

  if (getUrlData('channelCode') === 'jw') {
    localStorage.setItem('isJwApp', '1')
  }

  console.log('初始化开始当前时间', new Date().getTime())
  if (isApp()) {
    console.log('我是app', isApp())
    // H5提前注册桥
    try {
      window.updHeaders = callUpdHeaders
    } catch (e) {
      console.log('调用js失败', e)
    }
    // APP模式且非特殊页面情况下，需要走桥接方法拿数据
    try {
      await appBridgeInit()
      isShowApp.value = true
      if ((await checkAppHandle('iphoneStatusBarHeight')) && isIos()) {
        await getPhoneStatusBarHeight()
      }
      if (!localStorage.getItem('levelIconList')) {
        await getLevelIcon()
      }
    } catch (error) {
      console.log('桥接失败', error)
    }
  } else {
    storeData.isLocationUpdated = false
    storeData.isTechDetailDoFavAction = false
    storeData.isFirstVisitHome = true
    storeData.isShowNewSource = true
    storeData.v2PopupShowType = 0
    // 非APP模式(微信环境)走常规页面初始化
    await wxHeaderInfoInit()
    isShowApp.value = true
    if (storeData.appData.userId !== '') {
      bindUUidToUserId(storeData.appData.userId)
    }
    await Promise.all([
      // 获取优惠券活动信息
      !isNotLocationInit()
        ? getCouponsActivity().catch((e) => {
            console.error('获取优惠券活动失败:', e)
          })
        : Promise.resolve(),

      // 获取用户等级图标
      router.currentRoute.value.path !== '/pages/sharepay/index'
        ? getLevelIcon().catch((e) => {
            console.error('获取用户等级图标失败:', e)
          })
        : Promise.resolve(),

      // 广告参数初始化
      adCodeInit().catch((e) => {
        console.error('广告参数初始化失败:', e)
      }),
    ])

    // 定位操作异步执行
    if (!isNotLocationInit()) {
      locationInit().catch((e) => {
        console.error('定位初始化失败:', e)
      })
    }

    // 语音通话初始化，延迟逻辑已移至函数内部
    addGlobalVoiceCall().catch((e) => {
      console.error('语音通话初始化失败:', e)
    })
    await initBucket()
    await getBucket()

    // 其他非关键初始化
    if (
      !isWeiXin() &&
      !['videoVcPage', 'shareVideo', 'userSurvey', 'newCus', 'discountZone', 'wyStrict'].includes(router.currentRoute.value.name) &&
      !isJwApp()
    ) {
      isShowOpenAppPopup.value = true
    }

    if (jwAndroidApp()) {
      //0：默认，1：华为， 2：应用宝， 3：小米， 4：oppo， 5：vivo  6：三星
      sendDataToApp('fromAndroidChannel', null, (x) => {
        storeData.androidChannel = x
      })
    }
    storeData.globalRedPackRain.isClickHomeEntranceClose = false
    storeData.showGlobalSuspension = true
    storeData.lastVisitTechId = ''

    document.addEventListener('touchstart', handleTouchStart)
    document.addEventListener('scroll', handleScroll)

    onLCP(console.log)
    onCLS(console.log)
    onFID(console.log)
    onFCP(console.log)
  }

  await initDict()

  console.log('初始化完成当前时间', new Date().getTime())

  hideLoading()
})

const initBucket = async () => {
  const bucketKey = dayjs().format('bucket-YYYYMMDD')
  if (localStorage.getItem(bucketKey)) {
    storeData.bucket = localStorage.getItem(bucketKey)
    return
  }
  const res = await wyAuthService.cidBucket().catch(() => {})
  if (res.code === 0) {
    storeData.bucket = res.data
  }
}

watch(
  () => storeData.appData.userId,
  async (n) => {
    console.log('监听userId', n)
    if (n) {
      bindUUidToUserId(n)
      await addGlobalVoiceCall(1)
    }
  },
)

watch(
  () => isShowApp.value,
  async (n) => {
    if (n) {
      await new Promise((resolve) => setTimeout(resolve, 1500))
      await loadAliyunUploadSDK()
    }
  },
)

onUnmounted(() => {
  document.removeEventListener('touchstart', handleTouchStart)
  document.removeEventListener('scroll', handleScroll)
})

// 记录屏幕触摸开始时间
const handleTouchStart = () => {
  storeData.touchStartTime = new Date().getTime()
}

// 页面滚动
const handleScroll = () => {
  if (scrollTimer.value) clearTimeout(scrollTimer.value)

  if (storeData.isPageLeave) {
    storeData.isPageLeave = false
    return
  }

  const current = router?.currentRoute?.value?.name || ''
  const pageEventEnum = {
    homeModule: 'home_scroll_event',
    technicianList: 'techlist_scroll_event',
    technicianDetail: 'techdetail_scroll_event',
  }

  // 如果当前页面不在需要监听的列表中，直接返回
  if (!Object.keys(pageEventEnum).includes(current)) {
    return
  }

  const scrollTop = Math.ceil(document.documentElement.scrollTop || document.body.scrollTop)

  let ext
  if (['technicianList'].includes(current)) {
    if (getUrlData('defaultQuery')) {
      let newParam = getUrlData('defaultQuery') !== '' ? JSON.parse(getUrlData('defaultQuery')) : {}
      console.log(newParam)
      ext = {
        techType: newParam.hasOwnProperty('userType') && newParam.userType ? newParam.userType : 2,
      }
    } else {
      ext = {
        techType: 2,
      }
    }
  }
  if (current === 'technicianDetail') {
    ext = {
      techType: getUrlData('techType') || 2,
      tech_id: getUrlData('techId') || '',
    }
  }

  scrollTimer.value = setTimeout(() => {
    const scrollH = Math.abs(scrollTop - lastScrollTop.value)
    // 增加滚动距离阈值，减少不必要的上报
    if (scrollH > 50 && current) {
      const screenNum = Math.max(Math.ceil(scrollTop / document.documentElement.clientHeight), 1)
      console.log('滚动结束啦，事件名称为：', pageEventEnum[current])
      console.log('滚动结束啦，滚动屏数为：', screenNum)

      // 使用requestAnimationFrame确保在浏览器下一帧执行，避免阻塞
      requestAnimationFrame(() => {
        pageScrollUmengEmbedding(pageEventEnum[current], screenNum, ext)
        lastScrollTop.value = scrollTop
      })
    }
  }, 300)
}

// 监听消息收取
onMessage((messageList) => {
  console.log('收到消息了', messageList)
  if (!messageList || messageList.length === 0) return
  const message = checkMessage(messageList[0])
  console.log('转化后的消息', message)
  if (message && Object.keys(message).length > 0) {
    // 往全局队列里插数据
    resetArr(storeData.globalPopupList, storeData.globalPopupList.concat([message]))
    console.log('新的', storeData.globalPopupList)
    console.log('有v2弹窗吗', storeData.v2PopupShowType)
    // 如果有新消息主动触发一次弹出操作
    if (storeData.v2PopupShowType > 1) {
      storeData.showGlobalPopup = true
    }
  }
})

const addGlobalVoiceCall = async (type) => {
  const isDisabledIm = router.currentRoute.value?.meta?.disableIM || false
  if (!isApp() && storeData.appData.userId !== '' && !isDisabledIm) {
    await new Promise((resolve) => setTimeout(resolve, 2000))
    try {
      asyncComponent.value = defineAsyncComponent(() => import('./components/GlobalImVoiceCall.vue'))
      let imFunc = await import('@/hooks/useIm')
      await imFunc.TUIKitInit()
      if (type) {
        await imFunc.TUIKitLogout()
        await new Promise((resolve) => setTimeout(resolve, 10))
      }
      if ((await imFunc.TUIKitLogin()) && storeData.appData.userId !== '') {
        await imFunc.TUICallInit()
      }
    } catch (e) {
      console.log('初始化语音通话失败', e)
    }
  }
}

const adCodeInit = async () => {
  // 广告商推广id等参数初始化
  const pid = getUrlData('pid')
  const tid = getUrlData('tid')
  if (pid) {
    localStorage.setItem('pid', pid)
  }
  if (tid) {
    localStorage.setItem('tid', tid)
  }
}

const wxHeaderInfoInit = async () => {
  storeData.isEnterImMessage = false
  // 微信公众号模式下，初始化appData
  try {
    const channelCode = getUrlChannelCode()
    storeData.urlChannelCode = getUrlChannelCode()
    const localChannelCode = localStorage.getItem('channelCode')
    const latestChannelCode = localStorage.getItem('latestChannelCode')
    let utms = ''
    // 当前渠道码使用逻辑如下：(utms传值格式为 ’wyh5,xxx‘或者’wyh5‘)
    // 1、首次进入：如果没有渠道码，则默认赋值’wyh5‘，如果url中有渠道码，则给utms赋值该渠道码；
    // 2、第二次以及第n次进入：如果url携带了渠道码，则给utms的第二位赋值相应的渠道码，如果url中没有渠道码，则使用历史缓存的第二位渠道码，若历史中也没有则不赋值。有则替换，无则使用上次的；
    // 3、由于往约跟汗滴公用一个域名，所以针对utms中第一位渠道码如果是’hdh5‘的则手动改成’wyh5‘。
    if (channelCode) {
      // 首先看本地是否有缓存过
      if (localChannelCode) {
        // 校验是否是拉新分享的渠道码，此时只更新拉新utms，即utms的第一位
        if (checkIsInvite(channelCode)) {
          utms = channelCode
          if (latestChannelCode) {
            utms += ',' + latestChannelCode
          }
          localStorage.setItem('channelCode', channelCode)
        } else {
          utms = (localChannelCode === 'hdh5' ? 'wyh5' : localChannelCode) + ',' + channelCode
          localStorage.setItem('latestChannelCode', channelCode)
        }
      } else {
        localStorage.setItem('channelCode', channelCode)
        utms = channelCode
      }
    } else {
      if (localChannelCode) {
        utms = localChannelCode === 'hdh5' ? 'wyh5' : localChannelCode
        if (latestChannelCode) {
          utms += ',' + latestChannelCode
        }
      } else {
        localStorage.setItem('channelCode', 'wyh5')
        utms = 'wyh5'
      }
    }
    let meta = {
      os: 7, //公众号
      lang: 'zh-CN',
      utms: utmsCheck(utms),
    }
    const cid = getCID()
    storeData.headerInfo['c-id'] = `h-${cid}`
    storeData.headerInfo['c-meta'] = JSON.stringify(meta)
    storeData.appData.os = isWeiXin() ? 104006 : 104007
    storeData.isNeedRefreshTopicList = true
  } catch (error) {
    console.log('wxHeaderInfoInit失败', error)
  }
}

//所有字典初始化
const initDict = async () => {
  const res = await req.getSelectedDict({ codes: codeList })
  if (res.code === 0 && res.data.length > 0) {
    resetArr(storeData.allDict, res.data)
  }
  getServiceTel()
  hideLoading()
}

//是否展示天天优惠
const getCouponsActivity = async () => {
  let popParams = {
    cityCode: storeData.locationData.cityCode || '320200',
    latitude: storeData.locationData.latitude || 31.574729,
    longitude: storeData.locationData.longitude || 120.301663,
    os: storeData.appData.os || '104006',
    pid: localStorage.getItem('pid'),
    tid: localStorage.getItem('tid'),
    channelCode: localStorage.getItem('channelCode'),
    platformType: 0,
  }
  const res = await req.homePageSetting({ ...popParams })
  // storeData.dynamicShow = res.data.dynamicShow
  storeData.preferenceFlag = res.data.isPreferenceFill === 0
  storeData.productBuyCountShow = res.data.productBuyCountShow
  storeData.unlikeIdList.techIds = res.data.unlikeIdList.techIds || []
  storeData.unlikeIdList.ignoreShowTechIds = res.data.unlikeIdList.ignoreShowTechIds || []
  storeData.isShowCouponsActivity = res.data.isShowCouponsActivity === 1
  storeData.isShowCouponDiscount200 = res.data?.isShowCouponDiscount200 || 0
  storeData.isShowCouponDiscount30 = res.data?.isShowCouponDiscount30 || 0
  storeData.isEnableSkillTag = res.data?.isEnableSkillTag || 0
  storeData.isHandiEnableSkillTag = res.data?.isHandiEnableSkillTag || 0
}
//定位
const locationInit = async () => {
  if (!storeData.locationData.cityCode) {
    let result = await initAMap(3)
    console.log(69969666, result)
    if (!result?.cityCode) {
      result = defaultAddress
    }
    storeData.locationData.cityName = result.cityName
    storeData.locationData.cityCode = result.cityCode
    storeData.locationData.adcode = result.adcode
    storeData.locationData.longitude = result.longitude
    storeData.locationData.latitude = result.latitude
    storeData.locationData.position = result.position
    storeData.locationData.locationAddress = result.locationAddress
    storeData.locationData.formattedAddress = result.regeocode.formattedAddress
  }
}
//获取用户等级图标
const getLevelIcon = async () => {
  const res = await req.getConfig()
  localStorage.setItem('levelIconList', res.data.value)
}

//app初始化
const appBridgeInit = () => {
  return new Promise((resolve) => {
    sendDataToApp('getUserToken', null, async (result) => {
      let res = result
      console.log('拿到app数据', res)
      if (isAndroid()) {
        res = JSON.parse(res)
        //0：默认，1：华为， 2：应用宝， 3：小米， 4：oppo， 5：vivo  6：三星
        sendDataToApp('fromAndroidChannel', null, (x) => {
          storeData.androidChannel = x
        })
      }
      storeData.appData.cityName = res.cityName
      storeData.appData.cityCode = res.cityCode
      storeData.appData.adcode = res.adcode
      storeData.appData.cityAreaCode = res.cityAreaCode
      storeData.appData.lat = res.lat
      storeData.appData.lng = res.lng
      storeData.appData.os = res.os
      storeData.appData.userId = res.userId
      storeData.appData.version = res?.version || ''
      storeData.appData.hideShortVideo = res?.hideShortVideo || 0
      if (res.userId) {
        const puid = `uid-${res.userId}`
        setUserConfig({ puid })
        bindUUidToUserId(res.userId)
      }

      storeData.locationData.cityName = res.cityName
      storeData.locationData.cityCode = res.cityCode
      storeData.locationData.longitude = res.lng
      storeData.locationData.latitude = res.lat

      storeData.appData.os = isIos() ? '104002' : '104001'

      const info = res
      let metaInfo = isIos() ? info.cmeta : JSON.parse(info.cmeta)
      metaInfo['os'] = isIos() ? (metaInfo?.os === 9 ? metaInfo?.os : 9) : metaInfo?.os === 8 ? metaInfo?.os : 8
      storeData.headerInfo['c-meta'] = JSON.stringify(metaInfo)
      if (info.cid) {
        storeData.headerInfo['c-id'] = `h-${info.cid}`
        localStorage.setItem('AppCID', `${info.cid}`)
      } else {
        const cid = getCID()
        storeData.headerInfo['c-id'] = `h-${cid}`
        localStorage.setItem('AppCID', `app-${cid}`)
      }
      if (await checkIsNewPackage()) {
        console.log('我是新包')
        storeData.isShowNewSource = true
      } else {
        console.log('我是老包')
        storeData.appData.secret = res.secret
        storeData.appData.session = res.session
        storeData.appData.tecName = res.tecName
        storeData.appData.tecAvator = res.tecAvator
        storeData.appData.tecBirthday = res.birthday
        storeData.appData.tecPhone = res.phone
        storeData.appData.tecZodiac = res.zodiac
        storeData.appData.tecSex = res.sex
        if (!localStorage.getItem('expiresAt') || parseInt(localStorage.getItem('expiresAt')) * 1000 - new Date().getTime() <= 10000) {
          console.log('app调用刷新接口')
          let tsApi = await import('@/tsApi/service.ts')
          console.log(tsApi)
          try {
            await tsApi.resetWyExpiresAt()
          } catch (e) {}
        }
        storeData.isShowNewSource = false
      }
      if (await checkAppHandle('webviewRequestMethod')) {
        localStorage.setItem('isGoAppRequest', '1')
      }
      console.log('查看storeData', storeData)
      resolve(true)
    })
  })
}

// 获取顶部状态栏高度
const getPhoneStatusBarHeight = () => {
  return new Promise((resolve) => {
    try {
      sendDataToApp('iphoneStatusBarHeight', '', (res) => {
        console.log('状态栏高度', res)
        storeData.phoneStatusBarHeight = parseFloat(res.toString())
        resolve(true)
      })
    } catch (e) {
      resolve(true)
    }
  })
}

// 更新header
const callUpdHeaders = (val) => {
  if (val) {
    storeData.headerInfo['c-meta'] = val
  }
}

const componentOnMounted = () => {
  try {
    const skeletonDom = document.querySelector('#app-skeleton')
    const appDom = document.querySelector('#app')

    if (skeletonDom && appDom) {
      const styleDom = skeletonDom.querySelector('style')
      if (styleDom) {
        skeletonDom.removeChild(styleDom)
      }
      skeletonDom.style.display = 'none'
      appDom.style.display = ''
    }
  } catch (e) {
    console.error('骨架屏切换失败:', e)
  }
}

// 获取是否开通试验
const getBucket = async () => {
  const res = await req.getBuckets({ testNameList: ['TECH_SELF_VEDIO'] }).catch((e) => {
    console.log('technician:试验返回数据失败', e)
    storeData.selfVideoBucket = ''
  })
  console.log('technician:试验返回数据', res)
  if (res && res.code === 0) {
    storeData.selfVideoBucket = res.data?.tests[0]?.bucketName
  } else {
    storeData.selfVideoBucket = ''
  }
}

provide('isShowOpenAppPopup', isShowOpenAppPopup)
</script>

<style lang="scss">
@import './assets/iconfont/iconfont.css';
@import './assets/font/font.css';
@import './assets/style/style.scss';
</style>
